const buttonFilterUser = {
  label: 'filters'
};

export default buttonFilterUser;
